import { render, staticRenderFns } from "./TabelaSuspensa.vue?vue&type=template&id=3cd4eca3&scoped=true&"
import script from "./TabelaSuspensa.vue?vue&type=script&lang=js&"
export * from "./TabelaSuspensa.vue?vue&type=script&lang=js&"
import style0 from "./TabelaSuspensa.vue?vue&type=style&index=0&id=3cd4eca3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd4eca3",
  null
  
)

export default component.exports